import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, getLanguages, localeFallbacks, resolveLocale } from './registry';
import { createCatalogLoader } from './catalogLoader';

const loader = createCatalogLoader(locale => import(`../locales/${locale}.json`));

i18next.use(initReactI18next).init({
  resources: {},
  lng: DEFAULT_LOCALE,
  fallbackLng: code => localeFallbacks(code, 'marketing').slice(1),
  keySeparator: false,
  supportedLngs: getLanguages('marketing').map(language => language.code),
  interpolation: { escapeValue: false },
  returnNull: false,
  initImmediate: false,
  react: { useSuspense: false },
});

export function hasLocaleCatalog(value) {
  const locale = resolveLocale(value, 'marketing', null);
  return Boolean(locale && localeFallbacks(locale, 'marketing').every(code => loader.peek(code)));
}

export async function loadLocaleCatalog(value) {
  const locale = resolveLocale(value, 'marketing', null);
  if (!locale) throw new Error('Unsupported language');
  await Promise.all(localeFallbacks(locale, 'marketing').map(async code => {
    const catalog = await loader.load(code);
    i18next.addResourceBundle(code, 'translation', catalog, true, true);
  }));
  return locale;
}

export default i18next;
